import { useState } from "react";
import { Outlet } from "react-router-dom";
import { useAuthStore } from "../../../hooks";
import { styled, ThemeProvider } from "@mui/material/styles";
import { Nav } from "../../common/Nav/Nav";
import { Grid } from "@mui/material";
import { Role } from "../../../types/roles/roleTypes";
import { HeaderView } from "../../common/Header/Header";
import { platformTheme } from "../../../styles/platformTheme";

export const Layout: React.FC<any> = (): JSX.Element | any => {
  const { user } = useAuthStore();
  const userRole: Role | any = user.userType;

  const [openNew, setOpenNew] = useState(false);
  const APP_BAR_MOBILE = 64;
  // const APP_BAR_DESKTOP = (user.userType === Role.SUPER_ADMIN || user.userType === Role.ADMIN || user.userType === Role.MAINTENANCE) ? 80 : 75
  const APP_BAR_DESKTOP = 80;

  const StyledRoot = styled("div")({
    display: "flex",
    minHeight: "100vh",
    backgroundColor: "#F5F7FB",
  });

  const Main = styled("div")(({ theme }) => ({
    flexGrow: 1,
    height: `calc(100VH - ${75}px)`,
    marginTop: APP_BAR_MOBILE,
    padding: theme.spacing(1.5),
    backgroundColor: theme.palette.background.default,
    backgroundImage:
      "linear-gradient(rgba(1, 77, 223, 0.018) 1px, transparent 1px), linear-gradient(90deg, rgba(1, 77, 223, 0.018) 1px, transparent 1px)",
    backgroundSize: "32px 32px",
    overflow: "scroll",
    overflowX: "hidden",
    [theme.breakpoints.up("lg")]: {
      height: `calc(100VH - ${75}px)`,
      marginTop: APP_BAR_DESKTOP,
      padding: theme.spacing(2.5),
      overflow: "scroll",
      overflowX: "hidden",
    },
  }));

  return (
    <ThemeProvider theme={platformTheme}>
        <StyledRoot>
          {[Role.SUPER_ADMIN, Role.ADMIN, Role.AGENT].includes(userRole) ? (
            <Nav openNav={openNew} onCloseNav={() => setOpenNew(false)} />
          ) : (
            <HeaderView />
          )}
          <Main>
            {[Role.SUPER_ADMIN, Role.ADMIN, Role.AGENT].includes(userRole) ? (
              <Grid
                sx={{
                  minHeight: 600,
                  backgroundColor: "background.paper",
                  border: "1px solid",
                  borderColor: "divider",
                  borderRadius: 3,
                  boxShadow: "0 8px 28px rgba(20, 43, 83, 0.055)",
                  padding: { xs: 2, md: 3 },
                }}
              >
                <Outlet />
              </Grid>
            ) : (
              <Grid
                sx={{
                  minHeight: 600,
                  backgroundColor: "background.paper",
                  border: "1px solid",
                  borderColor: "divider",
                  borderRadius: 3,
                  boxShadow: "0 8px 28px rgba(20, 43, 83, 0.055)",
                }}
              >
                <Outlet />
              </Grid>
            )}
          </Main>
        </StyledRoot>
    </ThemeProvider>
  );
};
